import { TypographyProps } from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import useTypedContext from "hooks/useTypedContext";

import Typography from "../../Typography";
import { TileContext } from "../Context";
import styles from "./styles.module.css";

type TileTitleProps = {
  children: React.ReactNode;
  variant?: TypographyProps["variant"];
};

const TileTitle = ({ children, variant }: TileTitleProps) => {
  const { titleId } = useTypedContext(TileContext);

  return (
    <TextEllipsis tooltip={children} tooltipWidthMode="maxWidthSm">
      {(props) => (
        <Typography id={titleId} {...props} tag="span" className={styles.title} variant={variant}>
          {children}
        </Typography>
      )}
    </TextEllipsis>
  );
};

TileTitle.displayName = "DS.Tile.Title";

export default TileTitle;
